﻿window.addEventListener("DOMContentLoaded", window.yall);